import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/main-layout.js";
import { TextInput, Button } from '@undertheground/react';
import colors from '@undertheground/color';
import ButtonCover from '../images/ButtonIcon/ButtonCover.png';
import InputImage from '../images/InputCover.png';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <style>
    {`
    div{
  text-align: justify;
    }
.link {
    text-decoration: none;
    color: ${colors.pink[3]}
    }
.link:hover {
    color: ${colors.pink[6]}
}    
@media (max-width:790px){
    .image-responsive {
        display: none
    }
    .main-container {
        margin-left: 0.5rem !important;
        margin-right: 0.5rem !important;
        padding-top: 5rem
    }
}
    `}
    </style>
    <img className={'image-responsive'} style={{
      width: '100%'
    }} src={InputImage} />
    <div className={'main-container'} style={{
      marginLeft: '12rem',
      marginRight: "6rem"
    }}>
      <h1>{`Text Input`}</h1>
      <h6></h6>
      <h2>{`Overview`}</h2>
      <p>{`Text Input are used to create interactive controls for web-based forms in order to accept data from the user. Users could send their data in
wide varety of types. Although we could describe input as anything user send to the databases, we limited the ontology of the Text Input to an input with the string type value.
Therefore, date picker, file uploader and any other input formats doesn't include by this component.  `}</p>
      <h2>{`Usage`}</h2>
      <p>{`A `}<inlineCode parentName="p">{`<TextInput>`}</inlineCode>{` with `}<inlineCode parentName="p">{`leftIconName`}</inlineCode>{`, `}<inlineCode parentName="p">{`rightIconName`}</inlineCode>{`, `}<inlineCode parentName="p">{`name`}</inlineCode>{`, `}<inlineCode parentName="p">{`title`}</inlineCode>{`, and `}<inlineCode parentName="p">{`sizeType`}</inlineCode>{` has been represented below.`}</p>
      <h3>{`Live Demo`}</h3>
      <pre><code parentName="pre" {...{
          "className": "language-js"
        }}>{`
// for the matter of usage in React, we need import the component like below:
// import { TextInput } from '@undertheground/react';

<TextInput
  name="Password"
  leftIconName="password"
  placeholder="Exp: abas0098"
  sizeType="medium"
  title="Password"
  rightIconName="add"
/>


`}</code></pre>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      